type braintreeButtonStyles = {
  color?: "gold" | "blue" | "silver" | "white" | "black";
  height?: number;
  label?:
    | "paypal"
    | "checkout"
    | "buynow"
    | "pay"
    | "installment"
    | "subscribe"
    | "donate";
  layout?: "vertical" | "horizontal";
  shape?: "rect" | "pill";
  tagline?: boolean;
};

export const paymentBraintreeButtonStyles: braintreeButtonStyles = {
  color: "gold",
  label: "pay",
  shape: "rect",
};

export const disbursementBraintreeButtonStyles: braintreeButtonStyles = {
  color: "gold",
  label: "paypal",
  shape: "rect",
};
